import React from 'react';

import { BookOpenIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';

interface LabelProps {
  id: string;
  children: React.ReactNode;
  link?: string;
  className?: string;
}

export function Label({ id, children, link, className }: LabelProps) {
  const defaultClassName = 'block text-lg text-gray-700';

  const referenceLink = link ? (
    <a href={link} rel="noopener noreferrer" target="_blank">
      <div className="ml-3 flex items-center rounded-lg bg-gradient-to-tr from-[#1F8DF4] to-[#6CC1D4] px-2 py-1">
        <BookOpenIcon className="h-5 transform text-white transition-transform duration-200 group-hover:scale-110" />
        <span className="pl-1 text-base leading-6 text-white">Reference</span>
      </div>
    </a>
  ) : null;

  return (
    <div className="mb-3 flex items-center">
      <label
        className={clsx(className ? className : defaultClassName)}
        htmlFor={id}
      >
        {children}
      </label>
      {referenceLink}
    </div>
  );
}
